const STORAGE_MODES = {
  LOCAL: 'local',
  CENTRAL: 'central',
};

export default STORAGE_MODES;
